import { action } from 'mobx';
import stores from 'cd-eft/models/Stores';
import { appConfig } from 'cd-eft/config/AppConfig';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { UgoDesignToolsController, UgoFixtureTypeController, UgoPipelineMaterialTypeController } from 'cd-eft/services/eftSetApi';

const { ugoDesignStore, designStore } = stores.AppStore;

export function getManningsN(materialTypeId, pipeSize) {
    const pipelineMaterial = ugoDesignStore.pipelineMaterials.get(materialTypeId)
    const mg_array = pipelineMaterial?.mannningsNJson ? JSON.parse(pipelineMaterial?.mannningsNJson) : []
    let mg_selected: any = []
    if (mg_array) {
        if (mg_array.length === 1) {
            mg_selected = mg_array
        } else {
            mg_selected = mg_array.filter(mg => mg.pipeSize === pipeSize)
        }
        return (mg_selected && mg_selected.length > 0) ? (mg_selected[0].manningsN ? mg_selected[0].manningsN : 0) : 0
    }
    return 0;
}

export function getVerticalPipeLength(rimElevation: number, pipeFlowElev: number) {
    const length = rimElevation - pipeFlowElev;
    return parseFloat(length.toFixed(1));
}

export class UGOContainerVM {
    @action.bound async getErrors() {
        ugoDesignStore.notifications.unsavedEditsClosePage = await MessageCenter.addErrorLabelFromCode('Common_13');
    }

    @action.bound async getPipelineMaterialTypes() {
        if (ugoDesignStore.pipelineMaterials.size === 0 || ugoDesignStore.pipelineMaterialOptions.length === 0) {
            try {
                const response = await UgoPipelineMaterialTypeController.getAllUgoPipelineMaterialTypesUsingGET();
                const pipelineMaterials = response?.data || [];
                pipelineMaterials.forEach((pm) => {
                    ugoDesignStore.pipelineMaterials.set(pm.ugoPipelineMaterialTypeId ?? 0, pm);
                    ugoDesignStore.pipelineMaterialOptions.push({
                        name: pm.pipelineMaterialName ?? '',
                        value: pm.ugoPipelineMaterialTypeId ?? 0,
                    });
                });
            } catch (error) {
                MessageCenter.addError((error as Error).message);
            }
        }
    }

    @action.bound async getFixtureTypes() {
        if (ugoDesignStore.fixtureTypes.size === 0 || ugoDesignStore.fixtureTypeOptions.length === 0) {
            try {
                const response = await UgoFixtureTypeController.getAllUgoFixtureTypesUsingGET();
                const fixtureTypes = response?.data || [];
                fixtureTypes.forEach((ft) => {
                    ugoDesignStore.fixtureTypes.set(ft.ugoFixtureTypeId ?? 0, ft);
                    ugoDesignStore.fixtureTypeOptions.push({
                        name: ft.ugoFixtureTypeName ?? '',
                        value: ft.ugoFixtureTypeId ?? 0,
                    });
                });
            } catch (error) {
                MessageCenter.addError((error as Error).message);
            }
        }
    }

}

export const getUgoData = async (ugoId) => {
    ugoDesignStore.ugoDesignObject.alignedElementDesignParamsId = ugoId;
    designStore.designElementTypeId = appConfig.hardCodes.designElementTypeUGO; //To enable the PEM Toolbar in the map view during edit UGO.
    try {
        const response = await UgoDesignToolsController.loadUgoAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(
            ugoId
        );
        if (response.data) {
            const data = response.data;
            ugoDesignStore.ugoDesignObject = {
                ...ugoDesignStore.ugoDesignObject,
                ...data,
                ugoPipeSpecification: JSON.parse(data.designControlJson!),
                backFillSoilType: data.hydroParamsJson!,
            };
        }
    } catch (error) {
        MessageCenter.addError((error as Error).message);
    }
};
